import { healthLabel, healthTone } from "../lib/pilots";

// The pilot's computed health as a dot + label. `unknown` is "À qualifier", never a reassuring wording.
export default function PilotHealthBadge({ state, className = "", testid }) {
  const tone = healthTone(state);
  return (
    <span
      data-testid={testid || "pilot-health-badge"}
      data-health={state || "unknown"}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-2xs font-semibold ${tone.chip} ${className}`}
    >
      <span className={`h-2 w-2 rounded-full ${tone.dot}`} aria-hidden="true" />
      {healthLabel(state)}
    </span>
  );
}
